import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing, breakpoints }) => ({
  root: {
    marginBottom: spacing(3)
  },
  breadcrumbs: {
    marginBottom: spacing(2),
    [breakpoints.down('sm')]: {
      marginBottom: spacing(3)
    }
  },
  description: {
    marginBottom: spacing(4)
  },
  topics: {
    marginBottom: spacing(4)
  },
  pagination: {
    marginTop: spacing(4)
  },
  filterBar: {
    marginBottom: spacing(4)
  }
}))
